module.exports = __webpack_public_path__ + "img/main_menu_hover_5.bc7b416e.png";